// Everything that identifies the data retention surface, kept in one module so the screens can be
// mounted somewhere other than the accounts area (a Privacy/System Settings section is the likely
// destination) without hunting these values down across the app. The accounts page re-exports
// them for its tab; moving the surface means changing where the grid is mounted, not these.

// API entity the managed grid talks to.
export const RETENTION_ENTITY = 'dataRetentionFlag';

// Grid columns. Rows are keyed on email and accountId is nullable: guests, leads and event
// ambassadors are flagged without ever having an account.
export const retentionColumns = {
  EMAIL: 'email',
  ACCOUNT_ID: 'accountId',
  LAST_ACTIVITY_AT: 'lastActivityAt',
  LAST_ACTIVITY_TYPE: 'lastActivityType',
  FIRST_FLAGGED_AT: 'firstFlaggedAt',
  STATUS: 'status',
  ANONYMISED_AT: 'anonymisedAt'
};

// How many subjects one person may de-identify in a single action. A UI limit only: the API takes an
// unbounded list so the scheduled job can reuse it unchanged. Deliberately small while the process is
// manual, because every subject is meant to be reviewed individually. Raise it once the team is
// comfortable.
export const DEIDENTIFY_SELECTION_LIMIT = 5;

export const i18nKeys = {
  TAB_TITLE: 'account.tabs.retention-title',
  PANEL_ROOT: 'account.account-detail.retentionPanel',
  DEIDENTIFY_ROOT: 'account.account-detail.deidentify',
  DEIDENTIFY_AUDIT_ROOT: 'account.account-detail.deidentifyAudit'
};

// Every rule the panel can display, in the order the API returns them. Which rules come back
// varies by subject: an account contributes a login rule, one without an account does not, and
// accountCreated substitutes for login when the person never logged in. Keeping the list here
// means adding a DataRetentionActivityType only needs a label added below and the loading
// skeleton resizes itself.
export const retentionRules = [
  { rule: 'login', labelKey: `${i18nKeys.PANEL_ROOT}.rule.login` },
  { rule: 'donation', labelKey: `${i18nKeys.PANEL_ROOT}.rule.donation` },
  { rule: 'purchase', labelKey: `${i18nKeys.PANEL_ROOT}.rule.ticketPurchase` },
  { rule: 'lead', labelKey: `${i18nKeys.PANEL_ROOT}.rule.lead` },
  {
    rule: 'eventAmbassador',
    labelKey: `${i18nKeys.PANEL_ROOT}.rule.eventAmbassador`
  },
  { rule: 'createPage', labelKey: `${i18nKeys.PANEL_ROOT}.rule.createPage` }
] as const;
